import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import ErrorBoundary from './components/ErrorBoundary'
import { TRPCProvider } from './lib/trpc/hooks'
import { checkVersion, startVersionCheckInterval } from './utils/versionCheck'
import { initDevTools } from './lib/dev-tools'

// Initialize development tools (PocketMocker for API mocking)
initDevTools()

// Check for version mismatch and clear caches if needed before rendering
checkVersion().then((reloaded) => {
  if (reloaded) {
    console.log('🔄 Reloading for new version...')
    return // Page will reload automatically
  }

  // Render the app
  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <ErrorBoundary>
        <TRPCProvider>
          <App />
        </TRPCProvider>
      </ErrorBoundary>
    </StrictMode>,
  )

  // Start periodic version checking for long-running sessions
  startVersionCheckInterval()
})
